export enum SupplierType {
  ClinicSupplier = 'ClinicSupplier',
  PlatformSupplier = 'PlatformSupplier',
}
